import React, { useRef, useState } from 'react';
import { I } from '@/lib/icons';
import { useWorkspace, useExpenses } from '@/hooks/useData';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/components/Toast';
import { supabase } from '@/lib/supabase';
import { toIsoDate } from '@/lib/format';

const STORAGE_BUCKET = 'expense-docs';

export default function QuickCaptureFab() {
  const { workspace } = useWorkspace();
  const { user } = useAuth();
  const { create } = useExpenses(workspace?.id);
  const toast = useToast();
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  if (!workspace || !user) return null;

  const handleClick = () => fileRef.current?.click();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setBusy(true);
    const ext = (file.name?.split('.').pop() || 'jpg').toLowerCase();
    const path = `${user.id}/${workspace.id}/${Date.now()}.${ext}`;
    try {
      const { error: upErr } = await supabase.storage.from(STORAGE_BUCKET)
        .upload(path, file, { contentType: file.type || 'image/jpeg', upsert: false });
      if (upErr) throw upErr;
      const { data: pub } = supabase.storage.from(STORAGE_BUCKET).getPublicUrl(path);
      const docUrl = pub?.publicUrl || path;
      await create({
        vendor_name: null, vendor_ico: null, amount: 0,
        dph_rate: workspace.default_dph_rate || 0, dph_amount: 0,
        date: toIsoDate(), category: 'other',
        description: 'Rýchly záber — doplň polia.',
        paid_via: 'card', document_url: docUrl,
      });
      toast.success('Doklad uložený. Polia doplníš v sekcii Výdavky.');
    } catch (err) {
      toast.error('Upload zlyhal: ' + (err.message || err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: 'none' }}
        onChange={handleFile}
      />
      <button
        type="button"
        onClick={handleClick}
        disabled={busy}
        data-testid="quick-capture-fab"
        aria-label="Rýchly záber dokladu"
        title="Rýchly záber dokladu"
        style={{
          position: 'fixed', right: 24, bottom: 24, zIndex: 900,
          width: 56, height: 56, borderRadius: '50%',
          background: busy ? 'var(--text-muted)' : 'var(--product-primary)',
          color: '#fff', border: 'none', cursor: busy ? 'wait' : 'pointer',
          boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'transform 0.15s var(--ease)',
          fontFamily: 'inherit',
        }}
        onMouseEnter={e => { if (!busy) e.currentTarget.style.transform = 'scale(1.05)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
      >
        {busy
          ? <span className="cd-spinner" style={{ borderTopColor: '#fff' }} />
          : <I.camera width={22} height={22} />}
      </button>
    </>
  );
}
